// services/admin.service.ts
import { SupabaseClient } from "@supabase/supabase-js";

export async function getAdminByEmail({
  pool,
  email,
}: {
  pool: SupabaseClient;
  email: string;
}) {
  const { data, error } = await pool
    .from("admin")
    .select("id, email, role, nickname")
    .eq("email", email)
    .single();

  if (error || !data) {
    return {
      ok: false as const,
      error,
      data: null,
    };
  }

  return {
    ok: true as const,
    error: null,
    data,
  };
}
